import React, { PureComponent } from 'react';
import moment from 'moment';
import { DayPickerSingleDateController } from 'react-dates';
import { object, func, string } from 'prop-types';
import 'react-dates/lib/css/_datepicker.css';
import Icon from '../Icon/Icon';

const today = moment();

class StatisticDateFilterDatePicker extends PureComponent {
  static propTypes = {
    onChange: func.isRequired,
    date: object.isRequired,
    startDate: object.isRequired,
    endDate: object.isRequired,
    value: string.isRequired,
  };

  static defaultProps = {
    onChange() {},
    date: {},
    startDate: {},
    endDate: {},
    value: '',
  };

  state = {
    key: this.props.date.toISOString(),
  };

  getDateRange = (value, day, today, startDate, endDate) => {
    if (value === 'startDate') {
      return day.isAfter(today, 'day') || day.isAfter(endDate, 'day');
    } else {
      return !day.isBetween(startDate, today, 'day', '[]');
    }
  };

  getHighlightedDays = (day, startDate, endDate) => {
    return day.isBetween(startDate, endDate, 'day', '[]');
  };

  generateKey = () => {
    const { key } = this.state;
    const { date } = this.props;

    if (!moment(key).isSame(date, 'month')) {
      return date.toISOString();
    }
  };

  render() {
    const { onChange, date, value, startDate, endDate } = this.props;

    this.generateKey();

    return (
      <DayPickerSingleDateController
        key={this.generateKey()}
        onDateChange={date => onChange(date, value)}
        date={date}
        numberOfMonths={1}
        isOutsideRange={day => this.getDateRange(value, day, today, startDate, endDate)}
        isDayHighlighted={day => this.getHighlightedDays(day, startDate, endDate)}
        hideKeyboardShortcutsPanel
        weekDayFormat="dd"
        navPrev={
          <span>
            <Icon className="datepicker-icon datepicker-icon-prev" type="chevron-right" />
          </span>
        }
        navNext={
          <span>
            <Icon className="datepicker-icon datepicker-icon-next" type="chevron-right" />
          </span>
        }
        daySize={24}
        transitionDuration={0}
        focused
      />
    );
  }
}

export default StatisticDateFilterDatePicker;
